/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
window.Vue = require("vue");

import Popover from "vue-js-popover";
import InlineSvg from "vue-inline-svg";
import VueCountryCode from "vue-country-code";
const VueInputMask = require("vue-inputmask").default;
import SmartTable from "vuejs-smart-table";
import VueMoment from "vue-moment";
import VueCookies from "vue-cookies";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";

import VModal from "vue-js-modal";
import Notifications from "vue-notification";

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import VueSlider from 'vue-slider-component'
Vue.component('VueSlider', VueSlider)



Vue.use(Notifications);

Vue.use(Popover, { tooltip: true });
Vue.use(VueInputMask);
Vue.use(SmartTable);
Vue.use(VueMoment, {
    moment,
});
Vue.use(VModal);
Vue.use(VueCookies);
Vue.$cookies.config(60 * 60 * 24 * 30,'');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component("inline-svg", InlineSvg);
Vue.component("vue-country-code", VueCountryCode);
Vue.component("vue-date-picker", DatePicker);

//alerts
Vue.component("ccb-new-feature", require("./components/alerts/ccb-new-feature.vue").default);
Vue.component("check-payment-method", require("./components/alerts/check-payment-method.vue").default);
Vue.component("web-monitoring-active-incident", require("./components/alerts/web-monitoring-active-incident.vue").default);
Vue.component("web-monitoring-no-pages-for-check", require("./components/alerts/web-monitoring-no-pages-for-check.vue").default);
Vue.component("unblock-ip-new-feature", require("./components/alerts/unblock-ip-new-feature.vue").default);

//individuals
Vue.component("login-email-continue-button", require("./components/individuals/login-email-continue-button.vue").default);
Vue.component("show-os", require("./components/individuals/show-os.vue").default);
Vue.component("show-device", require("./components/individuals/show-device.vue").default);
Vue.component("show-blocking-reason", require("./components/individuals/show-blocking-reason.vue").default);
Vue.component("blocked-click-info", require("./components/individuals/blocked-click-info.vue").default);

//Inside app
Vue.component("send-reset-password-email", require("./components/blocks/send-reset-password-email.vue").default);

Vue.component("custom-input", require("./components/shared/custom-input.vue").default);

Vue.component("top", require("./components/top.vue").default);
Vue.component("important-message", require("./components/important-message.vue").default);
Vue.component("first-select-subscription", require("./components/first-select-subscription.vue").default);
Vue.component("select-subscription-plan", require("./components/select-subscription-plan.vue").default);
Vue.component("show-current-subscription", require("./components/show-current-subscription.vue").default);

Vue.component("connect-google-ads", require("./components/ConnectGoogleAds/connectGoogleAds.vue").default);
Vue.component("install-tracking", require("./components/ConnectGoogleAds/installTracking.vue").default);
Vue.component("success", require("./components/ConnectGoogleAds/success.vue").default);
Vue.component("dont-support-mcc", require("./components/ConnectGoogleAds/dontSupportMCC.vue").default);
Vue.component("conflict-detected", require("./components/ConnectGoogleAds/conflictDetected.vue").default);
Vue.component("trial-confirm", require("./components/ConnectGoogleAds/trialConfirm.vue").default);

Vue.component("email-verification", require("./components/setup/email-verification.vue").default);
Vue.component("profile", require("./components/setup/profile.vue").default);

//LandingPage
Vue.component("landing-page-dashboard", require("./components/LandingPage/landing-page-dashboard").default);
Vue.component("last-check", require("./components/LandingPage/last-check").default);
Vue.component("issues-history", require("./components/LandingPage/issues-history").default);
Vue.component("landing-settings", require("./components/LandingPage/settings").default);

Vue.component("agencyprogram", require("./components/blocks/agencyprogram.vue").default);
Vue.component("account", require("./components/blocks/account.vue").default);
Vue.component("campaign", require("./components/blocks/campaign.vue").default);
Vue.component("clicks", require("./components/blocks/clicks.vue").default);
Vue.component("webmonitoring", require("./components/blocks/webmonitoring.vue").default);
Vue.component("blocked-ip", require("./components/blocks/blocked-ip.vue").default);
Vue.component("blocking-settings", require("./components/blocks/blocking-settings.vue").default);
Vue.component("white-list", require("./components/blocks/white-list.vue").default);
Vue.component("account-settings", require("./components/blocks/account-settings.vue").default);
Vue.component("action-header", require("./components/shared/action-header.vue").default);
Vue.component("main-table", require("./components/shared/main-table.vue").default);

Vue.component("data-filter", require("./components/shared/filter.vue").default);

Vue.component("table-header", require("./components/shared/table-header.vue").default);

Vue.directive('tooltip', function(el, binding){
    $(el).tooltip({
        title:  document.getElementById(binding.value),
        html: true,
        placement: binding.arg,
        trigger: 'focus'
    });
})

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: "#app"
});
